import { Address } from 'viem';
import { Network } from '@kattana-io/common';
import SmallCurrencyIcon from '../../Trading/common/SmallCurrencyIcon';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { useTokensTableData } from './useTradesTableData';
import BodyTable from '../ModalTable/BodyTable';
import NumberDisplay from '../../../molecules/NumberDisplay';

import './styles.scss';

export interface IBalanceItem {
  contract_decimals: number;
  contract_name: string;
  contract_ticker_symbol: string;
  contract_address: string;
  supports_erc: string[];
  logo_url: string;
  last_transferred_at?: Date;
  type: string;
  balance: string;
  balance_24h: string;
  quote_rate: number;
  quote_rate_24h: number;
  quote: number;
  quote_24h: number;
  nft_data?: any;
}

export interface IProxyLimitToken {
  balance: number;
  tokenInfo: IBalanceItem;
}

export interface ITokensTableProps {
  network?: Network;
  tokens?: IProxyLimitToken[];
  onWithdraw: (address: Address, decimals: number, balance: string) => void;
}

const TokensTable = ({ tokens, network, onWithdraw }: ITokensTableProps) => {
  const { columns, data } = useTokensTableData({ tokens });

  const Cell = (cell: any, row: any): React.ReactNode => {
    const item: IBalanceItem = row.tokenInfo;
    const canWithdraw = row.balance > 0;
    switch (cell.column.id) {
    case 'token':
      return (
        <div className='modal_tokens_table_row__info'>
          <SmallCurrencyIcon
            network={network!}
            className='img'
            currency={item.contract_name}
            contract={item.contract_address}
            variant='m'
          />
          <Text size={14}>{item.contract_ticker_symbol}</Text>
        </div>
      );
    case 'quoteRate':
      return (
        <div className='modal_tokens_table_row__value'>
          <NumberDisplay
            value={item.quote_rate}
            startSymbol='$'
            textProps={{ size: 12 }}
          />
        </div>
      );
    case 'balance':
      return (
        <div className='modal_tokens_table_row__amount'>
          <NumberDisplay value={cell.value} textProps={{ size: 12 }} />
        </div>
      );
    case 'volumeUSD':
      return (
        <div className='modal_tokens_table_row__amount'>
          <Text size={12}>
            <NumberDisplay
              value={cell.value * item.quote_rate}
              textProps={{ size: 12 }}
            />
          </Text>
        </div>
      );
    case 'withdraw':
      return (
        <div className='modal_tokens_table_row__actions attach_right'>
          {canWithdraw ? (
            <Button
              size='s'
              variant='primary'
              action={() =>
                onWithdraw(
                  item.contract_address as Address,
                  item.contract_decimals,
                  item.balance
                )
              }
              text='Withdraw'
            />
          ) : null}
        </div>
      );
    default:
      return <Text size={12}>{cell.value}</Text>;
    }
  };

  return (
    <BodyTable
      data={data}
      columns={columns}
      renderCell={Cell}
      rowClass={'modal_tokens_table_row'}
    />
  );
};

export default TokensTable;
